module.exports = __webpack_public_path__ + "static/anne-pitman-works-with-patient-julie-truelove-at-the-ottawa-1d5e5d4ebeb35368c7339e031170d45a.jpg";